module.exports = {"350782001":"崇安街道","350782002":"新丰街道","350782003":"武夷街道","350782100":"星村镇","350782101":"兴田镇","350782102":"五夫镇","350782200":"上梅乡","350782201":"吴屯乡","350782202":"岚谷乡","350782203":"洋庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350782.json
// module id = 1228
// module chunks = 0